import React from 'react';
import '../../styles/corpoClinico.css';
import FonoAndreia from '../../img/corpoClinico/Fono.jpg';
import FonoAlessandra from "../../img/corpoClinico/FonoAlessandra.jpg";
import FonoBerenice from '../../img/corpoClinico/FonoBerenice.jpg';
import Lilian from '../../img/corpoClinico/Lilian.webp';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Fono">Corpo Clínico</h2>
      </div>

      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={FonoAndreia} alt="Berenice" />
            </div>
            <div className="info-container">
              <h3 className="nome">Andréa Liliane Farias Silva de Campos</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Andréa Liliane Farias Silva de Campos (CRFa 7-6173) é fonoaudióloga clínica e educacional, 
                formada pelo IMEC/POA, com pós-graduação em Reabilitação em Fonoaudiologia – ênfase em linguagem. 
                Terapeuta em Estimulação Precoce, multiplicadora do Método das Boquinhas, 
                coautora de materiais didáticos, coordenadora da Pós-graduação Boquinhas. 
                Mestranda em Intervenção Precoce, possui formação na ciência ABA, Comunicação Aumentativa e Alternativa-CAA e ampla experiência na avaliação e reabilitação de transtornos do neurodesenvolvimento, 
                além de mais de 20 anos atuando na formação de professores."
              </p>
            </div>
          </div>
        </div>
      </div>

       <div className="space"><br /></div>

      <div className="space"><br /></div>

      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={FonoAlessandra} alt="Alessandra"/>
            </div>
            <div className="info-container">
              <h3 className="nome">Alessandra M.de Moura</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Fonoaudióloga, formada pela faculdade IPA/IMEC. Possui Pós-graduação em reabilitação em fonoaudiologia com ênfase em audição pelo IPA/IMEC e 
                Curso de Pós-graduação em fonoaudiologia no Transtorno do Espectro Autista (TEA) pela Faculdade Metropolitana."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>

      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={FonoBerenice} alt="Berenice" />
            </div>
            <div className="info-container">
              <h3 className="nome">Berenice Klimuk Pereira Dias</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Berenice Klimuk Pereira Dias -
                Fonoaudióloga, atua no atendimento de crianças e adolescentes, nas áreas de fala,
                linguagem,  aprendizagem,  e motricidade orofacial.
                Formação em fonoaudiologia (IPA), especialização em Psicopedagogia Educacional
                (ULBRA), Pós- Graduação em psicopedagogia Clínica e institucional( Unilassalle), entre
                outros cursos livres na Academia do Autismo (ABA para pais aplicadores), na Supervisa (
                terapia de fala e motricidade orofacial), na Sociedade Brasileira de Fonoaudiologia (
                Telefonoaudiologia),  congressos e jornadas na área.  Registro no CRFa 7 - 9120/RS.
                Experiência em ONGs, vinculadas as prefeituras de Porto Alegre e Canoas."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="space"><br /></div>

      <div className="space"><br /></div>

      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={Lilian} alt="Lilian" className="img-fono-lilian"/>
            </div>
            <div className="info-container">
              <h3 className="nome">Lilian Pinto</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/
              }
              <p className="descricao">
                "Lilian Pinto especialista em audiologia, tem uma trajetória dedicada à saúde auditiva,
                com ampla experiência no diagnóstico, adaptação e reabilitação de pacientes com perda auditiva.  Atua  com:  Avaliação Auditiva,
                Teste de Aparelhos Auditivos, Vendas de Aparelhos, Conserto e Manutenção  de Aparelhos e Reabilitação Auditiva.
                Seu compromisso  é buscar fornecer um atendimento humanizado, ajudando cada paciente a encontrar a melhor solução para sua necessidade auditiva."
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;